import React from 'react';
import { Field } from 'react-final-form';

interface DisplayErrorProps {
  delay: number;
  active: boolean | undefined;
  dirty: boolean | undefined;
  error: any;
  touched: boolean | undefined;
  children: (error: any) => React.ReactNode;
}

const DisplayError = ({
  delay,
  active,
  dirty,
  error,
  touched,
  children,
}: DisplayErrorProps) => {
  const [show, setShow] = React.useState(false);
  React.useEffect(() => {
    let timeout: ReturnType<typeof setTimeout> | undefined;
    if (active && error && dirty) {
      timeout = setTimeout(() => setShow(true), delay);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [delay, error, active, dirty]);

  return error && ((touched && !active) || (touched && !show && active) || show)
    ? children(error)
    : null;
};

interface ErrorWithDelayProps {
  name: string;
  children: (error: any) => React.ReactNode;
  delay?: number;
}

const ErrorWithDelay = ({
  name,
  children,
  delay = 1000,
}: ErrorWithDelayProps) => (
  <Field
    name={name}
    subscription={{ active: true, error: true, dirty: true, touched: true }}
  >
    {({ meta: { active, dirty, error, touched } }) => (
      <DisplayError
        delay={delay}
        active={active}
        dirty={dirty}
        error={error}
        touched={touched}
      >
        {children}
      </DisplayError>
    )}
  </Field>
);

export default ErrorWithDelay;
